import { Drawer, Form } from "antd";
import { useTranslation } from "react-i18next";

import { LoginButton } from "@telegram-auth/react";
import { Image } from "antd-mobile";
import { envChangeType } from "../../plugins/utils.js";
import { AppBar } from "../index.js";
import { usePostBindTelegram } from "./hooks/bind.hook.js";
import TGIcon from "./images/tg_logo.png";
import "./style";
import styles from "./styleModule";

const BindTelegramPopup = ({ visible, setVisible, onBeforeFinish, title = null }) => {
  const { mutate: bindTelegram } = usePostBindTelegram();

  const { t } = useTranslation();
  const [form] = Form.useForm();

  const onClose = () => {
    setVisible(false);
    form.resetFields();
  };

  const onFinish = async (form) => {
    bindTelegram(form);
  };

  return (
    <Drawer
      placement="right"
      closable={false}
      onClose={onClose}
      destroyOnClose={true}
      visible={visible}
      bodyStyle={{ padding: "0" }}
      className="tg-popup"
      width={"100%"}
      style={{ maxWidth: "var(--maxWidth-in-pc)", margin: "0 auto" }}
    >
      <AppBar
        title={title ? title : t("normal.tg")}
        onClickEvent={() => {
          onClose();
        }}
      />
      <div className={styles.container}>
        <Image className={styles.icon} src={TGIcon} />
        <div className={styles.title}>{t("bind.tg.title")}</div>
        <div className={styles.subtitle}>{t("bind.tg.subtitle")}</div>
        <LoginButton
          botUsername={`${envChangeType("REACT_APP_TG_BOT")}`}
          onAuthCallback={async (data) => {
            await bindTelegram({ telegram_id: data.id });
            onBeforeFinish();
          }}
          buttonSize={"large"}
          showAvatar={false}
        />
      </div>
    </Drawer>
  );
};

export default BindTelegramPopup;
